'use client'
import { Retain } from '../../../atoms/Retain/Retain'
import { RetainBehaviorModifier, RetainSizeModifier } from '../../../atoms/Retain/constants/modifiers'
import React from 'react'
import type { LayoutPaneReactElement } from '../Types/LayoutPaneReactElement'

interface InnerLayoutProps {
    innerChildren: LayoutPaneReactElement[]
    retainSize: RetainSizeModifier
    layoutHasSidebar: boolean
    sidebarIsFixed: boolean
    sidebarIsOnLeftSide: boolean
    noPadding?: boolean
}
export const InnerLayout = ({
    innerChildren,
    retainSize,
    layoutHasSidebar,
    sidebarIsFixed,
    sidebarIsOnLeftSide,
    noPadding,
}: InnerLayoutProps): React.ReactElement => {
    // transform innerChildren into an array if it isn't already
    const innerChildrenArray = Array.isArray(innerChildren) ? innerChildren : [innerChildren]

    // get the sidebar from the innerChildren array, if it exists
    const sidebar = innerChildrenArray.filter((child) => {
        return child.props.paneType?.includes('sidebar')
    })[0]

    // get main content Element
    const main: LayoutPaneReactElement[] = innerChildrenArray.filter(
        (child) => !child.props.paneType?.includes('sidebar'),
    )

    // setup css classes
    const innerMainModifier = main.length <= 1 || !!noPadding ? ' o-layout__inner-main--no-gap' : undefined

    const retainPaddingClass =
        !layoutHasSidebar || !sidebarIsFixed
            ? ' o-retain--padding'
            : ` o-retain--padding-${sidebarIsOnLeftSide ? 'end' : 'start'}`

    const innerClasses = `o-layout__inner${sidebar?.props.paneType?.includes('left') ? ' o-layout__inner--reversed' : ''
        }${noPadding ? '' : retainPaddingClass}`

    return (
        <div className="o-layout__inner-scroll">
            <Retain
                sizeModifier={retainSize}
                behaviorModifiers={
                    retainSize === RetainSizeModifier.FULL_WIDTH ? [RetainBehaviorModifier.NO_PADDING] : []
                }
            >
                <div className={innerClasses}>
                    <div className={`o-layout__inner-main${innerMainModifier ?? ''}`} key={'content'}>
                        <>{main}</>
                    </div>
                    <>{sidebar}</>
                </div>
            </Retain>
        </div>
    )
}
